import {
  START_SIMULATOR,
  SUCCESS_SIMULATOR,
  ERROR_SIMULATOR,
  RESET_PATIENT_SIMULATOR,
} from "Actions/SimulatorAction";

const initialState = {
  createSimulatorData: {
    loading: false,
    data: [],
    error: {},
  },
};

export const SimulatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PATIENT_SIMULATOR: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_SIMULATOR: {
      let oldList = state?.createSimulatorData?.data;
      return {
        ...state,
        createSimulatorData: {
          loading: true,
          data: action?.appendData ? oldList : [],
          error: {},
        },
      };
    }
    case SUCCESS_SIMULATOR: {
      let oldList = state?.createSimulatorData?.data;
      if (action?.appendData) {
        oldList = [...oldList, ...action?.payload?.data];
      } else {
        oldList = action?.payload?.data;
      }

      return {
        ...state,
        createSimulatorData: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_SIMULATOR: {
      return {
        ...state,
        createSimulatorData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
